export default "__VITE_ASSET__CyHfP20I__"